<template>
  <div class="upsert-form">
    <div class="input-group">
      <dg-input type="text" v-model="formData.name" placeholder="Group name" />

      <div class="auto-enroll">
        <span class="label">Auto-enroll new members</span>
        <el-switch
          v-model="formData.autoEnroll"
          active-color="#13ce66"
          inactive-color="#CCC" />
      </div>

      <el-button type="primary" icon="el-icon-upload" :loading="saving" @click="handleClick">Save</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupsUpsertForm',
  props: {
    organization: {
      type: Object,
      required: true
    },
    group: {
      type: Object,
      required: false
    },
    editing: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      saving: false,
      formData: {
        name: '',
        autoEnroll: false
      }
    }
  },
  methods: {
    handleClick () {
      if (this.editing) {
        this.update()
      } else {
        this.add()
      }
    },
    async add () {
      this.saving = true
      try {
        const response = await this.$http.post(
          this.$api.organization(this.$route.params.orgId).groups,
          this.formData
        )
        this.$message.success('Group created')
        this.$emit('created', response.data)
      } catch (e) {
        this.$message.error(this.errorMessage(e) || 'Could not create group')
      } finally {
        this.saving = false
      }
    },
    async update () {
      this.saving = true
      try {
        const response = await this.$http.put(
          this.$api.organization(this.$route.params.orgId).group(this.group.id).update,
          this.formData
        )
        this.$message.success('Group updated')
        this.$emit('updated', response.data)
      } catch (e) {
        this.$message.error(this.errorMessage(e) || 'Could not update group')
      } finally {
        this.saving = false
      }
    },
    errorMessage (e) {
      if (e && e.response && e.response.data) {
        if (typeof e.response.data === 'string') return e.response.data
        if (e.response.data.message) return e.response.data.message
      }
      return null
    }
  },
  created () {
    if (this.group) {
      this.formData.name = this.group.name
      this.formData.autoEnroll = !!this.group.autoEnroll
    }
  }
}
</script>

<style lang="scss" scoped>
  .auto-enroll {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;

    .label {
      font-size: 13px;
      color: $text-light;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Groups/UpsertForm.vue